export type Contribution = {
  number: number
  title: string
  url: string
  mergedAt: string
  impact: string
  kind: 'Performance' | 'Memory' | 'Reliability'
}

export const contributions: Contribution[] = [
  {
    number: 21527,
    title: 'Add Q8_0 reorder optimization for Intel GPUs',
    url: 'https://github.com/ggml-org/llama.cpp/pull/21527',
    mergedAt: '2026-04-07T08:12:50Z',
    impact: '3.1× faster Q8_0 token generation on Arc Pro B70',
    kind: 'Performance',
  },
  {
    number: 21580,
    title: 'Add BF16 to the DMMV kernel path',
    url: 'https://github.com/ggml-org/llama.cpp/pull/21580',
    mergedAt: '2026-05-22T12:48:25Z',
    impact: '4.2× faster BF16 token generation on Arc Pro B70',
    kind: 'Performance',
  },
  {
    number: 21597,
    title: 'Use Level Zero allocations for multi-GPU inference',
    url: 'https://github.com/ggml-org/llama.cpp/pull/21597',
    mergedAt: '2026-05-14T05:39:15Z',
    impact: 'Reduced measured peak system RAM from 60 GB to about 6.7 GB',
    kind: 'Memory',
  },
  {
    number: 21638,
    title: 'Fix Q8_0 reorder corruption and full-VRAM crashes',
    url: 'https://github.com/ggml-org/llama.cpp/pull/21638',
    mergedAt: '2026-04-16T05:34:05Z',
    impact: 'Restored multi-prompt correctness and added an allocation fallback',
    kind: 'Reliability',
  },
  {
    number: 21700,
    title: 'Use native subgroup sizes for Intel K-quant kernels',
    url: 'https://github.com/ggml-org/llama.cpp/pull/21700',
    mergedAt: '2026-06-15T07:10:54Z',
    impact: 'Removed a model hang and aligned kernels with Intel’s native subgroup size',
    kind: 'Performance',
  },
  {
    number: 22035,
    title: 'Fix reorder MMVQ for unaligned vocabulary sizes',
    url: 'https://github.com/ggml-org/llama.cpp/pull/22035',
    mergedAt: '2026-04-20T05:39:45Z',
    impact: 'Fixed model-load assertions across four affected quantization formats',
    kind: 'Reliability',
  },
]
